import u from "./ui.module.css";

export default function Skeleton({
  width,
  height = 16,
  circle = false,
  className = "",
  style: styleProp,
}) {
  const style = {
    width: width || "100%",
    height: circle ? width || height : height,
    borderRadius: circle ? "50%" : undefined,
    ...styleProp,
  };
  return (
    <div
      className={`${u.skeleton} ${className}`}
      style={style}
      aria-hidden
    />
  );
}

export function SkeletonCard() {
  return (
    <div className={u.skeletonCard}>
      <Skeleton width="40%" height={20} />
      <Skeleton height={14} style={{ marginTop: 12 }} />
      <Skeleton height={14} width="70%" style={{ marginTop: 8 }} />
    </div>
  );
}
